import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import Navigation from './components/Navigation';
import DeviceMapPage from './components/DeviceMapPage';
import Registrations from './components/Registrations';
import ReportDetails from './components/ReportDetails';
import ReportJsonDetails from './components/ReportJsonDetails';
import LoginPage from './components/LoginPage';
import Tickets from './components/Tickets';
import DiagnosticsPage from './components/DiagnosticsPage';
import Documentation from './components/Documentation';
import { useGoogleAuth } from './contexts/GoogleAuthContext';
import { useIsAdmin } from './hooks/useIsAdmin';
import './styles/App.css';

const App: React.FC = () => {
    const isMsalAuthenticated = useIsAuthenticated();
    const { isGoogleAuthenticated } = useGoogleAuth();
    const isAuthenticated = isMsalAuthenticated || isGoogleAuthenticated;
    const isAdmin = useIsAdmin();

    return (
        <Router>
            {isAuthenticated ? (
                <div className="App">
                    <Navigation />
                    <Routes>
                        <Route path="/" element={<Registrations />} />
                        <Route path="/devices" element={<Registrations />} />
                        <Route path="/map" element={<DeviceMapPage />} />
                        <Route path="/uitleg" element={<Documentation />} />
                        <Route path="/summary" element={<Navigate to="/devices" replace />} />
                        <Route
                            path="/tickets"
                            element={isAdmin ? <Tickets /> : <Navigate to="/" replace />}
                        />
                        <Route
                            path="/diagnostics/:serialNumber"
                            element={isAdmin ? <DiagnosticsPage /> : <Navigate to="/" replace />}
                        />
                        <Route path="/system-reports" element={<Navigate to="/devices" replace />} />
                        <Route path="/registrations" element={<Navigate to="/devices" replace />} />
                        <Route path="/dashboard" element={<Navigate to="/devices" replace />} />
                        <Route path="/report/:serialNumber" element={<ReportDetails />} />
                        <Route path="/report/:serialNumber/:reportId" element={<ReportJsonDetails />} />
                    </Routes>
                </div>
            ) : (
                <LoginPage />
            )}
        </Router>
    );
};

export default App;